 import { useCallback, useState } from 'react';

const useDialogVisibility = (initialValue = false) => {
    const [isDialogVisible, setIsDialogVisible] = useState(initialValue);

    const openDialog = useCallback(() => {
        setIsDialogVisible(true)
    }, []);

    const closeDialog = useCallback(() => {
        setIsDialogVisible(false)
    }, []);

    return [isDialogVisible, openDialog, closeDialog]
  };

export default useDialogVisibility;
